<div class="warnings-component">
  <ng-content></ng-content>
</div>
